module.exports = __webpack_public_path__ + "img/IMG_5129.82ca0955.jpg";